import React, { useEffect, useState } from 'react'
import {
  message,
  Col,
  Row,
} from 'antd'
import courseTeacherMenuStyles from './course-main-teacher-menu.module.less'
import '../course.module.css'

import { checkUserLogin } from '../../common/user-center/user-info'
import {ExperimentOutlined,} from '@ant-design/icons'
import Cookies from 'js-cookie'
import { sendHttpPostRequest } from '../../../api/http-request'

import Icon from '@ant-design/icons'
import  {ReactComponent as myplaySvg }   from '../../../static/image/course/myplay.svg'
const myplayIcon = (props:any) => (<Icon component={myplaySvg} {...props} />)

import  {ReactComponent as myexerciseSvg }   from '../../../static/image/course/myexerciseorange.svg'
const myexerciseIcon = (props:any) => (<Icon component={myexerciseSvg} {...props} />)

import  {ReactComponent as myvideoSvg }   from '../../../static/image/course/myvideo.svg'
const myvideoIcon = (props:any) => (<Icon component={myvideoSvg} {...props} />)

import  {ReactComponent as mypdfSvg }   from '../../../static/image/course/mypdf.svg'
const mypdfIcon = (props:any) => (<Icon component={mypdfSvg} {...props} />)

export interface Props {
  menu_id: any
  course_user: string
  course_status: string
  course_id: number
}

/** 课程大纲标签页 */
export const MenuPreview: React.FC<Props> = (props) => {
  const { menu_id } = props
  const { course_user } = props
  const { course_status } = props
  const { course_id } = props
  const [menu, setMenu] = useState(null as any)
  const [user, setUser] = useState(course_user)
  const [status, setStatus] = useState(course_status)
  const [description, setDescription] = useState('')

  /**
   * 查询大纲
   */

  useEffect(() => {
    queryMenu()
  }, [])

  const queryMenu = () => {
    sendHttpPostRequest(
      'course/api/user_query_menu_by_id',
      {
        sessionid: Cookies.get('sessionid'),
        menu_id: menu_id,
        description: description,
        format: 1,
      },
      queryMenuCallback
    )
  }

  /**
   * 查询大纲回调
   * @param response
   */
  const queryMenuCallback = (response: any) => {
    // console.log(response)
    //message.destroy();
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (response.is_ok == true) {
      // 成功
      setMenu(response.query_info)
      setDescription(response.query_info.description)
    } else {
      message.error(response.message)
    }
  }



  const onKnowledgeClick = (chapter_id: number, knowledge_id: number) => {
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      if (!['未开始', '未加入', '已结束'].includes(course_status)) {
        window.open(
          `/course-learn?course/${course_id}/chapter/${chapter_id}/knowledge/${knowledge_id}/`
        )
      }
    }
  }

  return (
    <div>
      {menu?.json?.map((chapter, chapterInd) => (
        <div className={courseTeacherMenuStyles.chapterWrapper} key={chapterInd}>
          <div
            className={courseTeacherMenuStyles.chapterName}
            style={{ textAlign: 'left', fontWeight: 700 }}
          >
            {' '}
            {'第' + (chapterInd + 1) + '章 ' + chapter.name}
          </div>

          <div className={courseTeacherMenuStyles.modulesWrapper} >

            {chapter.tasks.map((module, moduleIndex) => (
              <div
                key={module.id}
                style={{ cursor: 'pointer' }}
                className={courseTeacherMenuStyles.modules}
                onClick={onKnowledgeClick.bind(this, chapter.id, module.id)}
              >
                <Row  wrap={false}  align="middle">
                  <Col style={{textAlign: 'left' }} flex="auto">
                    <div>
                      <div className={courseTeacherMenuStyles.moduleName}>{chapterInd + 1 + '.' + (moduleIndex + 1) + ' ' + module.name}</div>
                      <div className={courseTeacherMenuStyles.moduleDesp}>
                          {module?.type == 1 ? (
                              <span >
                               <Icon component={mypdfIcon}/>
                                PDF · {module?.lecture_pages}页
                              </span>
                            
                          ) : (
                           <span >
                              <Icon component={myvideoIcon}/>
                            视频 · {module?.video_duration_str}
                              </span>
                             
                          )}


                          {module.if_case && (
                              <span style={{marginLeft:16}}>
                                
                                <ExperimentOutlined style={{color:'rgb(168 85 247)'}}/>

                                含实验
                              </span>
                            )}

                            {module.if_practice && (
                              <span style={{marginLeft:16}}>
                                
                                <Icon component={myexerciseIcon}/>

                                含练习
                              </span>
                            )}

                      </div>
                    </div>



                  </Col>
                  <Col flex="60px" style={{ textAlign: 'right' }}>

                    <div> <span title='学习' className={courseTeacherMenuStyles.playIconWrapper}><Icon component={ myplayIcon}/></span></div>
                  
                  </Col>
                </Row>
              </div>
            ))}

          </div>
        </div>
      ))}
    </div>
  )
}

export default MenuPreview
